export var FCM_PLATFORM_CHANNEL = "platform";
export var FCM_PLATFORM_EVENT_TYPES = {
    adminSyncComplete: "admin_sync_complete",
    adminSyncFailed: "admin_sync_failed",
};
export var FCM_PLATFORM_DB_UPDATED = {
    true: "true",
    false: "false",
};
